

export function menu() {
    menu.prototype.menus = []
}
var m_seq_id = 1000
menu.prototype.bindMenus = function (m=[]) {
    menu.prototype.menus = m
    menu.prototype.menus.forEach((v) => {
        if (!v.__id) {
            m_seq_id++
            v.__id = m_seq_id + ""
        }
        if (!v.children) {
            return
        }
        v.children.forEach((m) => {
            if (!m.__id) {
                m_seq_id++
                m.__id = m_seq_id + ""
            }
            if (!m.children) {
                return
            }
            m.children.forEach((n) => {
                if (!n.__id) {
                    m_seq_id++
                    n.__id = m_seq_id + ""
                }
            })
        })
    })
}
menu.prototype.getMenuItem = function (url) {
    return menu.prototype.getMenuItemByMenus(menu.prototype.menus,url)
}
menu.prototype.getMenuItemByMenus=function(menus = [],url){
    var select = null
    menus.forEach((v) => {
        if (v.url && url && (v.url == url || v.path == url)) {
            select = v
            return
        }
        if (v.children) {
            select = menu.prototype.getMenuItemByMenus(v.children,url)
            return
        }
    })
    return select
}

menu.prototype.getSelectedMenu = function () {
    let menus = menu.prototype.menus
    for (let i = 0; i < menus.length; i++) {
        if (menus[i].selected) {
            return menus[i]
        }
    }
    return {}
}
menu.prototype.getSubMenus = function () {
    let menus = menu.prototype.menus
    for (let i = 0; i < menus.length; i++) {
        if (menus[i].selected) {
            return menus[i].children
        }
    }
    return []
}
menu.prototype.getSelectedMenuItem = function () {
    let menus = menu.prototype.menus
    for (let i = 0; i < menus.length; i++) {
        if (!menus[i].selected) {
            continue
        }
        let subMenus = (menus[i].children || [])
        for (let j = 0; j < subMenus.length; j++) {
            if (!subMenus[j].selected) {
                continue
            }
            if (!subMenus[j].children) {
                let mi = subMenus[j]
                mi.parent = menus[i]
                return mi
            }
            let menuItems = (subMenus[j].children || [])
            for (let m = 0; m < menuItems.length; m++) {
                if (menuItems[m].selected) {
                    let mi = menuItems[m]
                    mi.parent = subMenus[j]
                    mi.parent.parent = menus[i]
                    return mi
                }
            }
        }
    }
    return {}
}
menu.prototype.remove = function (vitem) {
    if (!vitem) {
        return
    }
    //查找默认选中的菜单
    menu.prototype.menus.forEach(function (v) {
        if (!v.children) {
            return
        }
        v.children.forEach(function (s1, index1, arr1) {
            if (equalItem(s1, vitem)) {
                arr1.splice(index1, 1)
                return
            }
            if (!s1.children) {
                return
            }
            s1.children.forEach(function (s2, index2, arr2) {
                if (equalItem(s2, vitem)) {
                    arr2.splice(index2, 1)
                    return
                }
            })
        })
    });


}


//字符串去空格
menu.prototype.switchMenu = function (vitem) {
    let menus = menu.prototype.menus
    let found = false
    let showSubMenu = false
    let firstMenu = null
    //当未指定选择项时，默认按当前选中的第一级进行选中加载
    if (!vitem) {
        menus.forEach(function (v) {
            if (v.selected) {
                vitem = v
            }
        })
    }
    //查找默认选中的菜单
    menus.forEach(function (v) {
        v.selected = false;
        if (!v.children) {
            return
        }
        if (equalItem(v, vitem)) {
            firstMenu = v
        }
        v.children.forEach(function (s1) {
            s1.selected = false
            if (equalItem(s1, vitem)) {
                s1.selected = true
                v.selected = true
                found = true
                showSubMenu = true
                firstMenu = v
                return
            }
            if (!s1.children) {
                return
            }
            s1.children.forEach(function (s2) {
                s2.selected = false
                if (equalItem(s2, vitem)) {
                    s2.selected = true
                    s1.selected = true
                    v.selected = true
                    found = true
                    showSubMenu = true
                    firstMenu = v
                    return
                }
            })
        })
    });
    if (!found) {
        if (menus.length > 0) {
            if (!firstMenu) {
                firstMenu = menus[0]
            }
            firstMenu.selected = true
            if (firstMenu.children && firstMenu.children.length > 0) {
                showSubMenu = true
                firstMenu.children[0].selected = true
                if (firstMenu.children[0].children && firstMenu.children[0].children.length > 0) {
                    firstMenu.children[0].children[0].selected = true
                }
            }
        }
    }

    return showSubMenu

    // if (!showSubMenu) {
    //     document.documentElement.style.setProperty("--submenu-width", "0px");
    // } else {
    //     document.documentElement.style.setProperty(
    //         "--submenu-width",
    //         "var(--submenu-origin-width)"
    //     );
    // }
}
function equalItem(a, b) {
    let xa = a || { params: "", __id: "", m_id: "" }
    let xb = b || { params: "", __id: "", m_id: "" }
    if (xa.params || xb.params) {
        return xa.params == xb.params
    }
    if (xa.__id || xb.__id) {
        return xa.__id == xb.__id
    }
    if (xa.m_id || xb.m_id) {
        return xa.m_id == xb.m_id
    }

    return false
}